export const GET_SELF_BILLING_INVOICES = gql`
    query selfBillingInvoices {
        selfBillingInvoices {
            id
            createdAt
            updatedAt
            partner {
                id
                name
                firstName
                lastName
            }
            sageInvoiceId
            sageInvoiceNumber
            status
            lineItems {
                description
                ledgerAccount
                lineTotal
                netAmount
                productOrService
                quantity
                totalVat
            }
            commissionStatements {
                statementDate
            }
        }
    }
`;

export const GET_SELF_BILLING_INVOICE = gql`
    query selfBillingInvoice($id: Int!) {
        selfBillingInvoice(id: $id) {
            id
            invoiceDate
            createdAt
            sageInvoiceNumber
            status
            partner {
                name
                billingContactInformation
                firstName
                lastName
                business {
                    legalName
                }
                partnerAccountNumber
                countryDetails {
                    currencies {
                        symbol
                    }
                }
            }
            # invoiceDate
            invoiceItems {
                description
                ledgerAccount
                commissionStatementId {
                    commissionStatementId
                    id
                }
                lineTotal
                netAmount
                productOrService
                quantity
                totalVat
            }
            status
            totals {
                invoiceAmount
                netAmount
                vatAmount
                outstandingAmount
            }
        }
    }
`;

export const GET_SELF_BILLING_INVOICE_PDF = gql`
    query GetSelfBillingInvoicePDF($id: Int!) {
        getSelfBillingInvoicePDF(id: $id) {
            downloadLink
            createdAt
        }
    }
`;
